$R.addLang('fr', {
    'properties': 'Propriétés'
});